import { Link } from 'foundations-components/transitional/components/Link';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { getUrl, getEntryUrlContext
// @ts-expect-error module not typed
} from 'conversations-message-history/context-update/operators/contextUpdateGetters';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { InfoIcon } from 'foundations-assets';
// @ts-expect-error module not typed
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import SystemMessage from 'conversations-inbox-message-history/system-message/SystemMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const EntryUrlContextSystemUpdate = ({
  message,
  ungatedForThreadMessagesUIImprovements
}) => {
  const getEntryUrlLink = entryUrl => {
    const url = getUrl(entryUrl);
    return /*#__PURE__*/_jsx(Link, {
      external: true,
      href: url,
      truncate: true,
      truncateStringProps: {
        matchContentWidth: true,
        useFlex: false,
        tooltip: false
      },
      use: "blue",
      children: url
    });
  };
  const entryUrl = getEntryUrlContext(message);
  return /*#__PURE__*/_jsx(SystemMessage, {
    timestamp: getTimestamp(message),
    description: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "conversations-thread-view.threadHistory.context-update-message.entryUrl",
      options: {
        entryUrl: getEntryUrlLink(entryUrl)
      }
    }),
    icon: /*#__PURE__*/_jsx(IconCircle, {
      borderWidth: "0",
      icon: InfoIcon,
      size: "500"
    }),
    ungatedForThreadMessagesUIImprovements: ungatedForThreadMessagesUIImprovements
  });
};
EntryUrlContextSystemUpdate.displayName = 'EntryUrlContextSystemUpdate';
export default EntryUrlContextSystemUpdate;